import React, { useEffect, useState, useContext } from 'react';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { getSharedEntry } from '../adapters/share-adapter';
import './css/flowentry_detail.css';
import styles from './css/share/shared-page.module.css';
import weekStoryStyles from './weekReflection/week-reflection.module.css'
import SwipeableFlowsContainer from './bigPicture/SwipeableFlowsContainer';
import SwipeableFlows from './bigPicture/SwipeableFlows';
import { getDateAndColorForEntries } from '../helpers/EntriesHelper';
import { getAuth } from 'firebase/auth';
import { useAuthState } from 'react-firebase-hooks/auth';
import { ShareLinkContext } from './share/ShareLinkContext';
import TimeContainer from '../TimeContainer';
import { GreetingColors } from '../Colors';
import { WeekReflectionContext } from './weekReflection/WeekReflectionContext';

import Stories from 'react-insta-stories';
import { ComponentMap } from './weekReflection/StoryComponentMap';

export function SharedContent() {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const queryPairs = Array.from(searchParams.entries());
    const [entryType, shareCode] = queryPairs.length > 0 ? queryPairs[0] : [null, null];
    const [sharedContent, setSharedContent] = useState();
    const [bannerText, setBannerText] = useState();
    const [errorMessage, setErrorMessage] = useState();

    const auth = getAuth();
    const [user] = useAuthState(auth);
    const { setIsContentReady, setSharerName } = useContext(ShareLinkContext);
    const { setTextInput, setLastStoryName, registerRestartStoriesFn } = useContext(WeekReflectionContext);

    useEffect(async () => {
        if (!entryType || !shareCode) {
            setErrorMessage('This link is invalid or no longer available.');
            return;
        }

        const result = await getSharedEntry(shareCode);
        if (!result || result.error) {
            setErrorMessage('This share is invalid or no longer available.');
            return;
        }

        if (result.sharerName) {
            setSharerName(result.sharerName);
        }

        let content, bannerText;
        if (entryType === 'flow') {
            bannerText = `${result.sharerName || 'A friend'} shared this flow`;
            // because swipeable flows need an array as input, even if only showing single flow
            const flowsArray = Array.isArray(result) ? result : [result];
            // converted to the ui flow objects.
            content = getDateAndColorForEntries(flowsArray);
        }
        else if (entryType === 'story') {
            content = createStoriesForWeek(result.stories, result.sharerName);
            bannerText = `${result.sharerName || 'A friend'} shared ${result.stories?.length > 1 ? 'week stories' : 'a story'} with you`;
            result.stories.forEach((story, i) => {
                if (!story.data) {
                    return;
                }

                let key = story.component;
                if (story.component.includes('recurringCause') && story.index !== undefined) {
                    key = key + story.index;
                }
                if (i === result.stories.length - 1) {
                    setLastStoryName(key);
                }
                setTextInput(prevInput => ({
                    ...prevInput,
                    [key]: story.data.comments ? story.data.comments : story.data.answer
                }))
            });

            registerRestartStoriesFn(restartStories);
        }
        else {
            // TODO: show some wrong link error
            return;
        }

        setSharedContent(content);
        setBannerText(bannerText);
        setIsContentReady(true); // updates the shared context variable used in other places

    }, [location.search, user]);

    const [restartCount, setRestartCount] = useState(0);
    const restartStories = () => {
        setRestartCount(prev => prev + 1);
    }

    const createStoriesForWeek = (storiesData, sharerName) => {
        const stories = storiesData.map(storyData => {
            const ComponentToRender = ComponentMap[storyData.component];
            const duration = storyData.duration;
            return {
                content: (props) => <ComponentToRender {...props} storyData={storyData} handleRestart={restartStories} />,
                duration: duration,
                storyData: storyData,
                view: 'readOnly',
                sharerName: sharerName
            };
        });

        return stories;
    }

    const getComponentForDisplay = () => {
        let jsx = <></>;

        if (entryType === 'flow') {
            jsx = <div className='checkin-details-page' style={{}}>
                <SwipeableFlowsContainer>
                    {bannerText &&
                        <div className={styles.banner}>
                            <p className={styles.bannerText}>{bannerText}</p>
                        </div>
                    }
                    <SwipeableFlows
                        flows={sharedContent}
                        handleChangeIndex={() => { }}
                        index={0}
                        animateHeight={false}
                        swipeHintStyle={sharedContent?.length > 1 ? { color: "white", fontSize: "12px", marginRight: "1rem" }
                            : { display: "none" }}
                    />
                </SwipeableFlowsContainer>
            </div>
        }
        else if (entryType === 'story') {
            let timeOfDay = new TimeContainer().getTimeOfDay();
            const timeOfDayBGColor = GreetingColors[timeOfDay].background;
            const style = user ? { width: "100%", paddingBottom: '2rem' } : { width: "100%", marginBottom: '3rem' }

            jsx = <div className={weekStoryStyles.storiesScreenBackground} style={style}>
                {bannerText &&
                    <div className={`${styles.banner} ${styles.storyBanner}`}>
                        <p className={styles.bannerText}>{bannerText}</p>
                    </div>
                }
                <Stories
                    key={restartCount}
                    stories={sharedContent}
                    defaultInterval={5000}
                    width={"100%"}
                    height={"85svh"}
                    storyContainerStyles={{
                        borderRadius: 8,
                        maxWidth: "360px",
                        maxHeight: "650px",
                        background: timeOfDayBGColor,
                        color: "white",
                    }}
                    progressContainerStyles={{ overflowX: 'clip' }}
                />
            </div>
        }

        return jsx;
    }

    return (
        sharedContent ?
            getComponentForDisplay()
            : errorMessage ?
                <div className={weekStoryStyles.storiesScreenBackground} style={{ background: 'unset' }}>
                    <div className={`${styles.banner} ${styles.storyBanner}`}>
                        <p className={styles.bannerText} style={{ textAlign: 'center' }}>
                            {errorMessage}
                        </p>
                    </div>
                </div> : <></>
    )
}
